"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStateList = void 0;
const React = __importStar(require("react"));
const use_mounted_state_1 = require("./use-mounted-state");
const use_update_1 = require("./use-update");
const use_update_effect_1 = __importDefault(require("./use-update-effect"));
function useStateList(stateSet = []) {
    const isMounted = (0, use_mounted_state_1.useMountedState)();
    const update = (0, use_update_1.useUpdate)();
    const index = React.useRef(0);
    (0, use_update_effect_1.default)(() => {
        if (stateSet.length <= index.current) {
            index.current = stateSet.length - 1;
            update();
        }
    }, [stateSet.length]);
    const actions = React.useMemo(() => ({
        next: () => actions.setStateAt(index.current + 1),
        prev: () => actions.setStateAt(index.current - 1),
        setStateAt: (newIndex) => {
            if (!isMounted())
                return;
            if (!stateSet.length)
                return;
            if (newIndex === index.current)
                return;
            index.current =
                newIndex >= 0
                    ? newIndex % stateSet.length
                    : stateSet.length + (newIndex % stateSet.length);
            update();
        },
        setState: (state) => {
            if (!isMounted())
                return;
            const newIndex = stateSet.length ? stateSet.indexOf(state) : -1;
            if (newIndex === -1) {
                throw new Error(`State '${state}' is not a valid state (does not exist in state list)`);
            }
            index.current = newIndex;
            update();
        },
    }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [stateSet]);
    return {
        state: stateSet[index.current],
        currentIndex: index.current,
        ...actions,
    };
}
exports.useStateList = useStateList;
//# sourceMappingURL=use-state-list.js.map